import { Route } from "react-router-dom";
import HomeLayout from "../themes/Home/HomeLayout";

const HomeRoutes = () => {
  return <Route path="/" element={<HomeLayout />}>
    <Route index element={<div>Welcome to the Home Page!</div>} />
  </Route>
}


export default HomeRoutes;